import { DEFAULT_USER_COUNTRY_CODE } from "@/lib/siteconfig/constants"

/**
 * Extracts the country code from a locale string (e.g., "en-se" -> "se")
 * Returns lowercase country code suitable for Depict market lookups
 */
export const getCountryCodeFromPreferredApp = (locale: string): string => {
    // No locale or Euro currency locales (en, fr, de) without country code
    if (!locale || !locale.includes("-")) {
        return DEFAULT_USER_COUNTRY_CODE
    }

    return locale.split("-")[1].toLowerCase()
}
